import React, { Component, createRef } from 'react';

import event from '../img/event.png'

export default class Info extends Component {
    constructor(props) {
        super(props);
        this.scrollDiv = createRef();
      }

    render() {
        return (
            <div className="info">
                <div className="bar">
                    <div className="seeRules" onClick={() => {
            this.scrollDiv.current.scrollIntoView({ behavior: 'smooth' });
          }}>
                        <p>See</p>
                        <p>Rules</p>
                    </div>
                    <div>
                        <p>May 1</p>
                        <p>2021</p>
                    </div>
                    <div>
                        <p>$32,000</p>
                        <p>In Payouts!</p>
                    </div>
                    <div>
                    <p>Hutchinson</p>
                    <p>Kansas</p>
                    </div>
                </div>
                <div className="event-img">
                    <img src={event} />
                </div>
                <div className="info-1">
                    <div>
                    <h1 className="green-underline">Calling all Diesel racers!</h1>
                    <h3>If you like the adrenaline of diesel racing on the street and winning cash, this event is for you! 1st person to cross the 1/8th mile finish, wins.</h3>
                    </div>
                    <div>
                        <h1>Where:</h1>
                        <p>12068 S McNew Rd. Hutchinson, KS 67501</p>
                        <h1>Date:</h1>
                        <p>Saturday, May 1 2021</p>
                        <h1>Elevation:</h1>
                        <p>1,535</p>
                    </div>

                    <div>
                        <h1>$20 Admission for Spectators</h1>
                        <p>Kids 12 & under are FREE</p>
                    </div>

                    <div>
                        <h1>$32,000 In Payouts</h1>
                        <p>Both Races will be treated like a Cash Day</p>
                        <p>100% payback for two full 32 truck field</p>
                        <p>Winner Takes All <span>(Finalist will have option to split)</span></p>
                    </div>
                </div>
                <div ref={this.scrollDiv} className="rules">
                    <h1 className="green-underline">RULES:</h1>
                    <h3>2 Classes</h3>
                    <div>
                        <h1>Street Class</h1>
                        <ul>
                            <li>Diesel Only</li>
                            <li>32 Trucks</li>
                            <li>16 from the West, 16 from the East</li>
                            <li>$500 buy in, paid before race, to lock in spot</li>
                            <li>No Refunds, we will fill your position with someone else</li>
                            <li>2 Captains, to choose the fastest street trucks in each region</li>
                            <li>Josh McCormack - West Captain</li>
                            <li>Cody Fisher - East Captain</li>
                            <br/>
                            <li>No Tire rules</li>
                            <li>Full OEM bed or manufactured flat bed besides race provisions, ex. holes for coolers, n2o, fuel tank</li>
                            <li>Back seat can be removed for crew or extended cab</li>
                            <li>Carpet/vinyl must be on floor and oem door panels </li>
                            <li>Oem firewall in factory location</li>
                            <li>Full oem dash required except modifications for safety equipment</li>
                            <li>Lexan only allowed on back window if caged</li>
                            <li>No fiberglass besides hood</li>
                            <li>One burnout only PYOP no water, can drive around</li>
                            <li>10 gallon fuel tank minimum</li>
                            <li>No solid or filled block/head, wet engines only</li>
                            <li>Working lights, brake lights and blinkers, besides ONE headlight</li>
                            <li>Must have two mirrors</li>
                            <li>Working wipers</li>
                            <li>Driver and passenger seat required either race or oem style</li>
                            <li>Working windows on driver/passenger side</li>
                            <li>Factory frame rails front to rear</li>
                            <li>Must be a registered and insured truck</li>
                            <li><b>If deemed unworthy of street driving you will be DQ</b></li>
                        </ul>
                    </div>    
                    <div>
                        <h1>"Run What You Brung" Class</h1>
                        <ul>
                            <li>$500 buy in, must be paid before race, to lock your spot in</li>
                            <li>If you pull out of race, no refunds. We will fill your position with some else</li>
                            <li>If too close to call, run it back at the end of group</li>
                            <li>First jump it's over</li>
                            <li>Chase is not a race</li>
                            <li>Tire cross over center line, you lose</li>
                            <li>ANY part of truck cross in front of other truck is a loss</li>
                            <br/>
                            <li>Helmet and fire jacket required with pants and closed toe shoes</li>
                            <li>Fire extinguisher in cab required</li>
                            <li>Fighting is grounds for automatic DQ</li>
                            <li>No Alcohol for drivers or crew</li>
                            <li>Anyone blocking cameras will be asked to move and if they don't they will be disqualified including the whole team</li>
                        
                            <li>Final call on all rules by race master</li>
                            <li>Cross bolts in exhaust preferred for safety</li>
                            <li>Water Cooling preferred, if you piss coolant on the track your holding the propane tank for me</li>
                        </ul>
                    </div>
                    <div className="info-1"><h1 className="green-underline">Deadline for Payment is April 2, 2021</h1></div>
              
                </div>
            </div>
        )
    }
}
